import React, { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { TiSocialFacebook } from "react-icons/ti";
import { AiOutlineYoutube } from "react-icons/ai";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    websiteType: "Web Development",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-orange-50">
        {/* Header Section with bg-gradient-to-r from-black to-logo */}
        <div className="relative py-16 md:py-24 bg-gradient-to-r from-blue-900 via-indigo-800 to-purple-900 text-white overflow-hidden">
          {/* Animated Background Elements */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-96 h-96 bg-orange-500 rounded-full transform -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
            <div className="absolute bottom-0 right-0 w-80 h-80 bg-yellow-400 rounded-full transform translate-x-1/2 translate-y-1/2 animate-bounce"></div>
            <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-orange-300 rounded-full transform -translate-x-1/2 -translate-y-1/2 animate-spin"></div>
          </div>

          <div className="container mx-auto px-6 text-center relative z-10">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in-up">
              Contact Us
            </h1>
            <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto leading-relaxed animate-fade-in-up delay-300">
              Any question or remarks? Just write us a message!
            </p>
          </div>
        </div>

        {/* Main Contact Section */}
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-12 gap-8 items-stretch">
              {/* Contact Information Card */}
              <div className="lg:col-span-5">
                <div className="bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 text-white rounded-3xl shadow-2xl p-8 h-full relative overflow-hidden transform hover:scale-105 transition-transform duration-500">
                  {/* Animated Background Decorations */}
                  <div className="absolute -bottom-32 -right-32 w-80 h-80 bg-gradient-to-r from-orange-500 to-red-500 rounded-full opacity-30 animate-pulse"></div>
                  <div className="absolute bottom-20 right-12 w-32 h-32 bg-orange-500 bg-opacity-50 rounded-full animate-bounce"></div>
                  <div className="absolute top-10 left-10 w-20 h-20 bg-yellow-400 bg-opacity-30 rounded-full animate-ping"></div>

                  <div className="relative z-10">
                    <h2 className="text-3xl font-bold mb-6 animate-fade-in-right">
                      Contact Information
                    </h2>
                    <p className="text-lg mb-8 opacity-90 animate-fade-in-right delay-200">
                      Fill up the form and our team will get back to you within
                      24 hours.
                    </p>

                    {/* Contact Details */}
                    <div className="space-y-6 mb-12">
                      <div className="flex items-center space-x-4 p-4 rounded-lg bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300 animate-fade-in-right delay-300">
                        <div className="text-2xl">📞</div>
                        <div>
                          <h3 className="font-semibold">Phone</h3>
                          <p className="opacity-90">+0123 4567 8910</p>
                        </div>
                      </div>

                      <div className="flex items-center space-x-4 p-4 rounded-lg bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300 animate-fade-in-right delay-400">
                        <div className="text-2xl">📧</div>
                        <div>
                          <h3 className="font-semibold">Email</h3>
                          <p className="opacity-90">hello@flowbase.com</p>
                        </div>
                      </div>

                      <div className="flex items-center space-x-4 p-4 rounded-lg bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300 animate-fade-in-right delay-500">
                        <div className="text-2xl">📍</div>
                        <div>
                          <h3 className="font-semibold">Address</h3>
                          <p className="opacity-90">102 Street 2714 Don</p>
                        </div>
                      </div>
                    </div>

                    {/* Social Media Links */}
                    <div className="animate-fade-in-right delay-600">
                      <h3 className="font-semibold mb-4 text-lg">Follow Us</h3>
                      <div className="flex space-x-4">
                        <a
                          href="https://www.instagram.com/astechcommunity/"
                          className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:text-red-500 hover:bg-white hover:bg-opacity-90 hover:scale-110 transition-all duration-300 group z-50"
                        >
                          <FaInstagram
                            size={25}
                            className="group-hover:animate-bounce"
                          />
                        </a>
                        <a
                          href="https://www.facebook.com/astechcommunity/"
                          className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:text-blue-600 hover:bg-white hover:bg-opacity-90 hover:scale-110 transition-all duration-300 group z-50"
                        >
                          <TiSocialFacebook
                            size={25}
                            className="group-hover:animate-bounce"
                          />
                        </a>
                        <a
                          href="https://www.linkedin.com/company/astechcommunity"
                          className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:text-blue-700 hover:bg-white hover:bg-opacity-90 hover:scale-110 transition-all duration-300 group z-50"
                        >
                          <FaLinkedinIn
                            size={25}
                            className="group-hover:animate-bounce"
                          />
                        </a>
                        <a
                          href="https://www.youtube.com/AnumShaheen"
                          className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:text-red-600 hover:bg-white hover:bg-opacity-90 hover:scale-110 transition-all duration-300 group z-50"
                        >
                          <AiOutlineYoutube
                            size={25}
                            className="group-hover:animate-bounce"
                          />
                        </a>
                        <a
                          href="https://chat.whatsapp.com/Ly9eCbbsdtkGeL9pOoQKg1"
                          className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:text-green-500 hover:bg-white hover:bg-opacity-90 hover:scale-110 transition-all duration-300 group z-50"
                        >
                          <FaWhatsapp
                            size={25}
                            className="group-hover:animate-bounce"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="lg:col-span-7">
                <div className="bg-white rounded-3xl shadow-2xl p-8 h-full transform hover:shadow-3xl transition-shadow duration-500">
                  <h2 className="text-3xl font-bold text-gray-900 mb-8 animate-fade-in-left">
                    Send Us a Message
                  </h2>

                  <div className="space-y-6">
                    {/* Name Fields */}
                    <div className="grid md:grid-cols-2 gap-6 animate-fade-in-left delay-200">
                      <div className="group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-orange-500 transition-colors">
                          First Name *
                        </label>
                        <input
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all duration-300 hover:border-orange-300"
                          placeholder="Enter your first name"
                          required
                        />
                      </div>
                      <div className="group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-orange-500 transition-colors">
                          Last Name *
                        </label>
                        <input
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all duration-300 hover:border-orange-300"
                          placeholder="Enter your last name"
                          required
                        />
                      </div>
                    </div>

                    {/* Email and Phone */}
                    <div className="grid md:grid-cols-2 gap-6 animate-fade-in-left delay-300">
                      <div className="group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-orange-500 transition-colors">
                          Email Address *
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all duration-300 hover:border-orange-300"
                          placeholder="example@mail.com"
                          required
                        />
                      </div>
                      <div className="group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2 group-focus-within:text-orange-500 transition-colors">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all duration-300 hover:border-orange-300"
                          placeholder="+90 543 779 94 64"
                        />
                      </div>
                    </div>

                    {/* Service Type */}
                    <div className="animate-fade-in-left delay-400">
                      <label className="block text-sm font-semibold text-gray-700 mb-4">
                        What type of website do you need? *
                      </label>
                      <div className="grid md:grid-cols-2 gap-4">
                        {[
                          "Web Design",
                          "Web Development",
                          "Logo Design",
                          "Other",
                        ].map((service, index) => (
                          <label
                            key={service}
                            className="flex items-center p-4 border-2 border-gray-200 rounded-xl cursor-pointer hover:border-orange-300 hover:bg-orange-50 transition-all duration-300 group"
                          >
                            <input
                              type="radio"
                              name="websiteType"
                              value={service}
                              checked={formData.websiteType === service}
                              onChange={handleInputChange}
                              className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
                            />
                            <span className="ml-3 text-gray-700 font-medium group-hover:text-orange-600 transition-colors">
                              {service}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Message */}
                    <div className="animate-fade-in-left delay-500">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Message *
                      </label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="5"
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all duration-300 hover:border-orange-300 resize-none"
                        placeholder="Tell us about your project requirements..."
                        required
                      ></textarea>
                    </div>

                    {/* Submit Button */}
                    <div className="animate-fade-in-left delay-600">
                      <button
                        onClick={handleSubmit}
                        disabled={isSubmitted}
                        className="w-full bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white py-4 px-8 rounded-xl font-semibold text-lg hover:from-orange-600 hover:via-red-600 hover:to-pink-600 transform hover:scale-105 hover:shadow-2xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                      >
                        {isSubmitted ? (
                          <>
                            <span className="animate-spin">⚡</span>
                            <span>Message Sent!</span>
                          </>
                        ) : (
                          <>
                            <span>🚀</span>
                            <span>Send Message</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  {isSubmitted && (
                    <div className="mt-6 p-4 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl animate-fade-in">
                      <p className="text-green-800 text-center font-medium">
                        🎉 Thank you for your message! We'll get back to you
                        within 24 hours.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white py-16 animate-gradient-x">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-fade-in-up">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto animate-fade-in-up delay-200">
              Join hundreds of satisfied clients who have transformed their
              digital presence with our expertise.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center animate-fade-in-up delay-400">
              <div className="flex items-center space-x-2 text-lg bg-white bg-opacity-20 px-6 py-3 rounded-full backdrop-blur-sm hover:bg-opacity-30 transition-all duration-300">
                <span className="animate-pulse">✅</span>
                <span>24/7 Support</span>
              </div>
              <div className="flex items-center space-x-2 text-lg bg-white bg-opacity-20 px-6 py-3 rounded-full backdrop-blur-sm hover:bg-opacity-30 transition-all duration-300">
                <span className="animate-bounce">⚡</span>
                <span>Quick Response</span>
              </div>
              <div className="flex items-center space-x-2 text-lg bg-white bg-opacity-20 px-6 py-3 rounded-full backdrop-blur-sm hover:bg-opacity-30 transition-all duration-300">
                <span className="animate-pulse">👥</span>
                <span>Expert Team</span>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes fade-in-up {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fade-in-left {
            from {
              opacity: 0;
              transform: translateX(-30px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes fade-in-right {
            from {
              opacity: 0;
              transform: translateX(30px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes gradient-x {
            0%,
            100% {
              background-size: 200% 200%;
              background-position: left center;
            }
            50% {
              background-size: 200% 200%;
              background-position: right center;
            }
          }

          .animate-fade-in-up {
            animation: fade-in-up 0.8s ease-out forwards;
          }

          .animate-fade-in-left {
            animation: fade-in-left 0.8s ease-out forwards;
          }

          .animate-fade-in-right {
            animation: fade-in-right 0.8s ease-out forwards;
          }

          .animate-gradient-x {
            animation: gradient-x 3s ease infinite;
          }

          .delay-200 {
            animation-delay: 0.2s;
          }

          .delay-300 {
            animation-delay: 0.3s;
          }

          .delay-400 {
            animation-delay: 0.4s;
          }

          .delay-500 {
            animation-delay: 0.5s;
          }

          .delay-600 {
            animation-delay: 0.6s;
          }
        `}</style>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
